module.exports = __webpack_public_path__ + "img/liverpool-toluca.7dcfef2e.jpg";